var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"app index"},[(!_vm.isAuthenticated)?_c('IndexNavigation'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }